import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PermissionService } from './services/permission/permission.service';

@Component({
  selector: 'App',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  private permissionService: PermissionService = inject(PermissionService);

  ngOnInit() {
    const token = sessionStorage.getItem('access_token');

    if (token && this.permissionService.getUserPermissions().length === 0) {
      this.permissionService.setUserPermissions();
    }
  }
}
